import { Add, Close, Edit, SwipeUp } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Spin } from 'antd';
import ButtonMui from '@mui/material/Button';
import Billetage from '../../../Billetage';
import InputForm from '../../../InputT';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Data from "../../../../Data/Data.json";
import { LoadBilletage } from '../../../../Functions/Traitement/LoadBilletage';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';

export default function ValideLitige(props: { adherant?: any, label?: string, title?: string, form?: any, data?: any, onFinish: any }) {
    const [open, setOpen] = React.useState(false);
    const [isOk, setIsOk] = useState<boolean>(false)
    const { register, handleSubmit } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [loading, setLoading] = useState<boolean>(false)


    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const handleClickOpen = () => {
        setOpen(true);
        // alert(JSON.stringify(props.data))
        props.form.setFieldsValue(props.data)
        // chargement du billetage
        LoadBilletage({
            form: props.form,
            authHeader: authHeader(),
            user: user,
            Ref: props.form.getFieldValue("NUMRAP"),
            ColRef: "RefOperation",
            Table: 'billetageOperationLitige'
        })
        // getToatal()
    };

    const handleClose = () => {
        setOpen(false);
    };

    // function getToatal() {
    //     props.form.setFieldValue('TotalBilletage', 
    //     formatNumber(
    //       parseInt((props.form.getFieldValue("NOMB01")? props.form.getFieldValue("NOMB01") : 0))*10000+
    //       parseInt((props.form.getFieldValue("NOMB02")? props.form.getFieldValue("NOMB02") : 0))*5000+
    //       parseInt((props.form.getFieldValue("NOMB03")? props.form.getFieldValue("NOMB03") : 0))*2000+
    //       parseInt((props.form.getFieldValue("NOMB04")? props.form.getFieldValue("NOMB04") : 0))*1000+
    //       parseInt((props.form.getFieldValue("NOMB05")? props.form.getFieldValue("NOMB05") : 0))*500+
    //       parseInt((props.form.getFieldValue("NOMB06")? props.form.getFieldValue("NOMB06") : 0))*500+
    //       parseInt((props.form.getFieldValue("NOMB07")? props.form.getFieldValue("NOMB07") : 0))*100+
    //       parseInt((props.form.getFieldValue("NOMB08")? props.form.getFieldValue("NOMB08") : 0))*50+
    //       parseInt((props.form.getFieldValue("NOMB09")? props.form.getFieldValue("NOMB09") : 0))*25+
    //       parseInt((props.form.getFieldValue("NOMB10")? props.form.getFieldValue("NOMB10") : 0))*10+
    //       parseInt((props.form.getFieldValue("NOMB11")? props.form.getFieldValue("NOMB11") : 0))*5+
    //       parseInt((props.form.getFieldValue("NOMB12")? props.form.getFieldValue("NOMB12") : 0))*2+
    //       parseInt((props.form.getFieldValue("NOMB13")? props.form.getFieldValue("NOMB13") : 0))*1)
    //     )
    //   }

    setTimeout(() => {
        try {
            let reset = localStorage.getItem(Data.LocalVariable.reset)
            if (reset == "1") {
                setOpen(false)
            }
        }
        catch (error) { }
    }, .1)
    return (
        <div>
            <Tooltip title={props.title} >
                <ButtonMui style={{ borderBottomRightRadius: "0px", borderBottomLeftRadius: "0px" }} color='success' onClick={handleClickOpen}>C</ButtonMui>
            </Tooltip>

            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Dialog maxWidth={false} style={{ zIndex: 1, marginLeft: "12%" }} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <Box height={30} display={'flex'}>
                        <DialogTitle textAlign={"center"} id="form-dialog-title"><b>Confirmation Litige . . .</b></DialogTitle>
                        {/* <hr color='white' />
                        <ButtonMui variant='outlined' style={{ boxShadow: "none" }} color='error' size='small' onClick={handleClose} ><Close /></ButtonMui> */}
                    </Box>
                    <DialogContent>
                        <Billetage form={props.form} withTatal />
                    </DialogContent>
                    <DialogActions style={{ marginTop: "-2.5%" }}>

                        <Button onClick={props.onFinish} size='large' className='bt_add' type="ghost" htmlType="submit" block>
                            Confirmer
                        </Button>
                        <Button color='error' size='large' onClick={handleClose} className='bt_add' type="ghost" htmlType="submit" block>
                            Fermer
                        </Button>


                    </DialogActions>
                </Dialog>
            </Spin>
        </div>
    );
}
